module.exports = __webpack_public_path__ + "static/media/tab-front.494cd883.png";